import { render, staticRenderFns } from "./CompetenciesList.vue?vue&type=template&id=7fab5c8c"
import script from "./CompetenciesList.vue?vue&type=script&lang=js"
export * from "./CompetenciesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports